/* Ivalro — microanimaciones (vanilla JS, sin librerías).
   Las animaciones en sí son CSS (hm-motion.css). Este archivo solo:
   · marca como visibles (.hm-in) los bloques [data-hm-motion] al entrar en pantalla,
   · cuenta del precio del bote al coste por día ([data-hm-count]),
   · pausa el bucle del hero cuando no se ve,
   · simula el "hover" al tocar las tarjetas de objetivo en móvil.
   Con "reducir movimiento" no anima nada: deja los valores finales. */
(function () {
  if (window.__hmMotionInit) return;
  window.__hmMotionInit = true;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- 1) bloques que se animan al verse ---------- */
  function initMotion(root) {
    var els = (root || document).querySelectorAll('[data-hm-motion]:not([data-hm-motion-ok])');
    if (!els.length) return;
    function go(el) { el.setAttribute('data-hm-motion-ok', '1'); el.classList.add('hm-in'); }
    if (!hasIO || reduce) { els.forEach(go); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { go(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.35 });
    els.forEach(function (el) { io.observe(el); });
    // Salvavidas: si algo queda sin activar (scroll muy rápido, pestaña en 2º plano), se activa solo.
    setTimeout(function () {
      els.forEach(function (el) {
        if (el.classList.contains('hm-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) go(el);
      });
    }, 2500);
  }

  /* ---------- 2) contador: precio del bote → coste por día ---------- */
  function fmt(v, cur, loc) {
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(v); }
    catch (e) { return v.toFixed(2); }
  }
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function initCount(root) {
    var els = (root || document).querySelectorAll('[data-hm-count]:not([data-hm-count-ok])');
    els.forEach(function (el) {
      el.setAttribute('data-hm-count-ok', '1');
      var num = el.querySelector('[data-hm-num]');
      var from = parseFloat(el.getAttribute('data-from'));
      var to = parseFloat(el.getAttribute('data-to'));
      var cur = el.getAttribute('data-cur') || 'EUR';
      var loc = document.documentElement.lang || 'es';
      var finalTxt = el.getAttribute('data-final') || (num && num.textContent);
      if (!num || isNaN(from) || isNaN(to) || reduce) return; // se queda el valor final del servidor

      var started = false;
      function run() {
        if (started) return; started = true;
        var dur = 1700, t0 = null;
        num.textContent = fmt(from, cur, loc);
        function tick(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          num.textContent = fmt(from + (to - from) * ease(p), cur, loc);
          if (p < 1) requestAnimationFrame(tick);
          else { num.textContent = finalTxt; el.classList.add('hm-cuenta-fin'); }
        }
        requestAnimationFrame(tick);
        // salvaguarda: si el navegador congela las animaciones (pestaña en segundo plano), se muestra el valor final
        setTimeout(function () { if (!el.classList.contains('hm-cuenta-fin')) { num.textContent = finalTxt; el.classList.add('hm-cuenta-fin'); } }, dur + 900);
      }
      if (!hasIO) { run(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { run(); io.disconnect(); }
      }, { threshold: 0.6 });
      io.observe(el);
      setTimeout(function () { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 0.9 && r.bottom > 0) run(); }, 3000);
    });
  }

  /* ---------- 3) bucle del hero: pausa fuera de pantalla ---------- */
  function initLoop(root) {
    (root || document).querySelectorAll('[data-hm-loop]:not([data-hm-loop-ok])').forEach(function (el) {
      el.setAttribute('data-hm-loop-ok', '1');
      // El bucle arranca cuando la página ya ha cargado, para no competir con la carga
      function arrancar() {
        if (window.requestIdleCallback) requestIdleCallback(function () { el.classList.add('hm-loop-on'); }, { timeout: 1500 });
        else setTimeout(function () { el.classList.add('hm-loop-on'); }, 200);
      }
      if (document.readyState === 'complete') arrancar();
      else window.addEventListener('load', arrancar, { once: true });
      if (!hasIO) return;
      new IntersectionObserver(function (en) {
        el.classList.toggle('hm-paused', !en[0].isIntersecting);
      }, { threshold: 0.05 }).observe(el);
      document.addEventListener('visibilitychange', function () {
        el.classList.toggle('hm-paused', document.hidden);
      });
    });
  }

  /* ---------- 4) tarjetas de objetivo: el "toque" hace de hover ---------- */
  function initTap() {
    document.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      var card = e.target.closest && e.target.closest('.hm-obj-card');
      if (!card) return;
      card.classList.remove('hm-tap');
      void card.offsetWidth; // reinicia la animación
      card.classList.add('hm-tap');
      setTimeout(function () { card.classList.remove('hm-tap'); }, 1200);
    }, { passive: true });
  }

  function boot(root) { initMotion(root); initCount(root); initLoop(root); }
  function ready() { boot(document); initTap(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  // Editor de temas de Shopify: al añadir o recargar una sección, la animación se vuelve a enganchar.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
